export enum AddressType {
  Inhabitant = 1,
  Correspondence = 2
}
